// GA4 事件追蹤。事件規格見 msg-server-go/docs/analytics-events.md，
// 所有前端共用 Firebase 專案 sakamessage 連結的 GA4 property。
// 元件只呼叫這裡匯出的函式，不直接碰 window.gtag。
import { GROUP_CODES } from '../config/groups';

// Firebase web app「message web」的 measurement ID（公開值，非機密）
const MEASUREMENT_ID = 'G-0NK0RR3XF5';

// 只在正式建置送資料；開發時改印到 console 方便檢查
const enabled = import.meta.env.PROD;

let initialized = false;

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;
  if (!enabled) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // page_view 由 trackPageView 依路由手動送，避免與自動 page_view 重複計算
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
  window.gtag('set', 'user_properties', { app_variant: 'web' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
};

export const setUserProperty = (name, value) => {
  if (!enabled) {
    console.debug('[analytics] user_property', name, value);
    return;
  }
  window.gtag?.('set', 'user_properties', { [name]: value });
};

export const logEvent = (name, params = {}) => {
  if (!enabled) {
    console.debug('[analytics]', name, params);
    return;
  }
  window.gtag?.('event', name, params);
};

// 路徑 → 規格中的 screen_name
export const screenNameForPath = (pathname) => {
  const first = pathname.split('/')[1] || '';
  if (first === '') return 'home';
  if (first === 'members') return 'message';
  if (first === 'groups' || GROUP_CODES.includes(first)) return 'group';
  if (first === 'profile') return 'user_info';
  if (first === 'year-in-review') return 'year_in_review';
  if (first === 'ios-app') return 'download';
  if (first === 'login-required') return 'login';
  if (['complete-profile', 'pending', 'expired', 'forbidden'].includes(first)) return 'auth_gate';
  if (['stats', 'payment', 'download', 'admin'].includes(first)) return first;
  return 'other';
};

export const trackPageView = (location) => {
  logEvent('page_view', {
    page_location: window.location.href,
    page_path: location.pathname + location.search,
    page_title: document.title,
    screen_name: screenNameForPath(location.pathname),
  });
};

const subscriptionStatus = (user, isExpired) => {
  if (user.isAdmin) return 'admin';
  if (isExpired) return 'expired';
  if (!user.isActive) return 'pending';
  return 'active';
};

// 使用者資料變動時呼叫；user 為 null 代表未登入
export const setAnalyticsUser = (user, isExpired = false) => {
  const props = user
    ? { auth_state: 'member', subscription_status: subscriptionStatus(user, isExpired) }
    : { auth_state: 'guest', subscription_status: null };
  if (!enabled) {
    console.debug('[analytics] user', user?.id ?? null, props);
    return;
  }
  window.gtag?.('config', MEASUREMENT_ID, {
    send_page_view: false,
    user_id: user ? String(user.id) : null,
  });
  window.gtag?.('set', 'user_properties', props);
};
